export enum MmRoutesEnum {
      projects = 'projects',
      faults = ':projectId/faults',
      plans = ':projectId/plans',
      user_variables = ':projectId/configurations/user/variables',
      project_companies = ':projectId/configurations/companies',
      project_crafts  = ':projectId/configurations/crafts',
      project_variables = ':projectId/configurations/variables',
      project_type1 = ':projectId/configurations/userdefineds/type1',
      project_type2 = ':projectId/configurations/userdefineds/type2',
      access_denied = 'access_denied'

}
